import {
  TemplateExpressionValidationError,
  validateTemplateExpressions,
} from '@monetize/expression-parser';
import { useMemo } from 'react';

const NO_ERRORS: TemplateExpressionValidationError[] = [];

/**
 * Validate the `{{...}}` template expressions inside rich text content.
 * Returns one entry per invalid expression, or an empty (stable) array when
 * the content is clean.
 */
export function useTemplateExpressionValidation(
  content: string | null | undefined,
): TemplateExpressionValidationError[] {
  return useMemo(() => {
    if (!content) {
      return NO_ERRORS;
    }
    const errors = validateTemplateExpressions(content);
    return errors.length === 0 ? NO_ERRORS : errors;
  }, [content]);
}
